export const applyProperties = (target, source) => {

    for (var key in source) {

        if (source.hasOwnProperty(key)) {

            target[key] = source[key];

        }

    }

};
